import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getVoiceAnalyses = asyncThunkWrapper({ 
  model: 'voiceAnalyses', 
  action: 'getVoiceAnalyses', 
  func: async ({ offset = 0 }) => {
    const attributes = ['id', 'input', 'status', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes };
    const response = await axios.get('/voice_flow/voice_analyses', { params });

    return response.data;
  } 
});
export const getVoiceAnalysis = asyncThunkWrapper({ 
  model: 'voiceAnalyses', 
  action: 'getVoiceAnalysis', 
  func: async ({ id, cable = false }) => {
    const attributes = ['id', 'input', 'result', 'voice', 'status', 'updated_at'];
    const params = { attributes };
    const response = await axios.get(`/voice_analyses/${id}`, { params });

    return { data: response.data, cable };
  } 
});
export const clearLocalVoiceAnalyses = createAction('voiceAnalyses/clearLocalVoiceAnalyses');
export const clearLocalActiveVoiceAnalysis = createAction('voiceAnalyses/clearLocalActiveVoiceAnalysis');